import React, { useMemo, useState } from 'react'
import styled from 'styled-components'
import ImageComponentHead from '../../../../../generic/imageComponents/ImageComponentHead'
import Image from '../../../../../generic/assets/delivery.png'
import { IFreightCompanyItem } from '../../../../../modules/API/Defaults/models/freightCompany'
import { FormShell, FormGrid, FormField, FormFooter } from '../../../../../generic/ui/FormLayout'
import OptionSelect, { IOption } from '../../../../../generic/ui/Selectors/OptionSelect'
import Checkbox from '../../knisot/Create/Components/Checkbox'
import { AccentButton } from '../../../../../generic/ui/Button/AccentButton'
import { useTranslation } from 'react-i18next'


interface Props {
  list: IFreightCompanyItem[]
  defaultID: number
  setFreightCompanyID: (id: number) => void
  selectedItemDestination: {
    id: string,
    growerID: number,
    customerID: number,
    freightCompanyID: number
  } | null
  handleChangeFreightCompany: (id: number, isPermanent: boolean) => void
}

  const ModalSelectFreightCompany = ({
    list,
    defaultID,
    setFreightCompanyID,
    selectedItemDestination,
    handleChangeFreightCompany
  }: Props) => {
    const [t] = useTranslation('buttons')
    const [isNeedToSetPermanent, setIsNeedToSetPermanent] = useState(false)
    const handleChangeOrder = () => {
      if(!selectedItemDestination) return
      handleChangeFreightCompany(defaultID, isNeedToSetPermanent)
    }
    const handleChangePermanent = () => {
      setIsNeedToSetPermanent(!isNeedToSetPermanent)
    }
    const options = useMemo<IOption[]>(
      () => list.map((item) => ({ value: item.FC_ID, label: item.FC_Name })),
      [list]
    )
    const effectiveID = defaultID || selectedItemDestination?.freightCompanyID || 0
    const selectedOption = options.find((o) => o.value === effectiveID) ?? null
  return (
    <FormShell>
      <ImageComponentHead img={Image} />
      <FormGrid>
        <FormField label='חיפוש חברת הובלה'>
          <OptionSelect
            options={options}
            value={selectedOption}
            onSelect={(option) => setFreightCompanyID(option?.value ?? 0)}
            placeholder='חברת הובלה'
          />
        </FormField>
        <FormField label='שמור למגדל'>
          <ToggleRow>
            <Checkbox
              checked={isNeedToSetPermanent}
              onChange={handleChangePermanent}
            />
          </ToggleRow>
        </FormField>
      </FormGrid>
      <FormFooter>
        <AccentButton
          type='button'
          onClick={handleChangeOrder}
          fullWidth={false}
        >
          {t('save')}
        </AccentButton>
      </FormFooter>
    </FormShell>
  )
}

const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.625rem;
  min-height: 2.875rem;
  padding: 0 0.25rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    min-height: 2.5rem;
  }
`
export default ModalSelectFreightCompany
